/** @type {import('tailwindcss').Config} */
import config from './tailwind.config.mjs';

export default {
	...config,
	content: [
		...config.content,
		"./astro/**/*",
		"./js/render/**/*",
		// "./custom/apps/download/**/*",
		"./custom/components/**/*",
		"./custom/form/**/*",
		"./custom/frontend/**/*",
		"./custom/layout/**/*",
		"./templates/pages/404.html",
	],
}
